<template>
    <b-container>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{
                    $t('form.create', {
                        item: $t('unitsOfMeasurement.unitOfMeasurement'),
                    })
                }}</strong>
            </b-card-header>
            <b-card-body>
                <Form @onSubmit="onSubmit" />
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import notification, { success, danger } from '@/lib/notification'
import Form from './components/Form'
import { userPermissionsMixin } from '@/mixins'

notification.init()

export default {
    name: 'New',
    components: {
        Form,
    },
    mixins: [userPermissionsMixin],
    mounted() {
        if (
            !this.currentUserHasRolePermissionsOf(['god', 'administrator', 'local_administrator', 'is_target_master'])
        ) {
            this.$router.push({
                path: '/v2/pages/error/403',
            })
        }
    },
    methods: {
        redirectToList() {
            this.$router.push({
                path: '/v2/target/units-of-measurement/list',
            })
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.post('/units-of-measurement', form)
                .then(() => {
                    onReset()
                    this.notificationUnitOfMeasurementCreatedSuccessfully()
                    this.redirectToList()
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationUnitOfMeasurementCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('unitsOfMeasurement.unitOfMeasurement'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
